// 1st Option is always the Default selected
export const PRODUCT_TYPES_OPTIONS = ["GOLD", "SILVER", "PLATINUM", "DIAMOND"];
export const GENDER_OPTIONS = ["MALE", "FEMALE", "UNISEX", "KIDS"];
export const PRODUCT_STATUS_OPTIONS = ["ACTIVE", "INACTIVE"];
export const PRODUCT_VIEW_ACCESS_OPTIONS_ALL = [
  { value: "B2C_APP", label: "B2C Mobile App" },
  { value: "B2C_WEBSITE", label: "B2C Website" },
  { value: "B2B_WEBSITE", label: "B2B Website" },
  { value: "B2B_APP", label: "B2B Mobile App" },
  //   { value: "ALL", label: "All Platforms" },
];

export const PRODUCT_VIEW_ACCESS_OPTIONS = [
  { value: "B2C_APP,B2B_APP", label: "Mobile App" },
  { value: "B2C_WEBSITE,B2B_WEBSITE", label: "Website" },
  //   { value: "ALL", label: "All Platforms (Both)" },
];

export const USE_ALL_PRODUCT_VIEW_ACCESS_OPTIONS = false;

// Add these to your existing constants
export const PRODUCT_FEATURES = {
  STOCK_MANAGEMENT: "stockManagement",
  BULK_OPERATIONS: "bulkOperations",
  IMPORT_EXPORT: "importExport",
  HALLMARK_MANAGEMENT: "hallmarkManagement",
  PRICING_CALCULATOR: "pricingCalculator",
  SEO_MANAGEMENT: "seoManagement",
  ADVANCED_FILTERS: "advancedFilters",
  PRODUCT_REPORTS: "productReports",
};

export const STOCK_OPERATIONS = {
  SET: "set",
  ADD: "add",
  SUBTRACT: "subtract",
  TRANSFER: "transfer",
};

export const BULK_OPERATION_TYPES = {
  STATUS_UPDATE: "status",
  STOCK_UPDATE: "stock",
  PRICING_UPDATE: "pricing",
  BRANCH_UPDATE: "branch",
  CUSTOM_UPDATE: "custom",
};

export const IMPORT_EXPORT_FORMATS = {
  EXCEL: "excel",
  CSV: "csv",
  JSON: "json",
  PDF: "pdf",
};

// Product Types NEW once
export const PRODUCT_TYPE_ENUM = [
  "GOLD",
  "SILVER",
  "PLATINUM",
  "DIAMOND",
  "STUDDED",
];

export const PRODUCT_STATUS_ENUM = ["ACTIVE", "INACTIVE", "DRAFT", "ARCHIVED"];
export const PRODUCT_GENDER_ENUM = ["MALE", "FEMALE", "UNISEX", "KIDS"];
export const VIEW_ACCESS_ENUM = [
  "B2C_APP",
  "B2C_WEBSITE",
  "B2B_WEBSITE",
  "B2B_APP",
];

// Purity Levels
export const PURITY_ENUM = ["24K", "22K", "18K", "14K", "925", "950", "PT950"];
export const METAL_COLOR_ENUM = [
  "YELLOW",
  "WHITE",
  "ROSE",
  "TWO_TONE",
  "THREE_TONE",
];

// Stone Types
export const STONE_TYPE_ENUM = [
  "DIAMOND",
  "RUBY",
  "EMERALD",
  "SAPPHIRE",
  "PEARL",
  "TOPAZ",
  "AMETHYST",
  "OTHER",
];

export const STONE_SHAPE_ENUM = [
  "ROUND",
  "PRINCESS",
  "OVAL",
  "MARQUISE",
  "PEAR",
  "CUSHION",
  "EMERALD",
  "ASSCHER",
  "RADIANT",
  "HEART",
];

export const STONE_SETTING_ENUM = [
  "PRONG",
  "BEZEL",
  "CHANNEL",
  "PAVE",
  "TENSION",
  "HALO",
  "CLUSTER",
];

// Certifications
export const CERTIFICATION_TYPE_ENUM = [
  "BIS_HALLMARK",
  "GIA",
  "IGI",
  "SGL",
  "HRD",
  "AGS",
  "DGLA",
];

export const CERTIFICATION_AGENCY_ENUM = [
  "BIS",
  "GIA",
  "IGI",
  "SGL",
  "HRD",
  "AGS",
  "DGLA",
];

// Product Categories
export const PRODUCT_SUBTYPE_ENUM = [
  "RING",
  "NECKLACE",
  "EARRING",
  "BRACELET",
  "PENDANT",
  "CHAIN",
  "BANGLE",
  "ANKLET",
  "NOSE_PIN",
  "MANGALSUTRA",
  "KADA",
  "COIN",
  "BAR",
  "IDOL",
  "OTHER",
];

// Collections & Occasions
export const COLLECTION_TYPE_ENUM = [
  "WEDDING",
  "FESTIVAL",
  "DAILY_WEAR",
  "OFFICE_WEAR",
  "PARTY",
  "TRADITIONAL",
  "MODERN",
];

export const OCCASION_ENUM = [
  "WEDDING",
  "ENGAGEMENT",
  "ANNIVERSARY",
  "BIRTHDAY",
  "FESTIVAL",
  "GIFT",
  "INVESTMENT",
];

// Craft Types
export const CRAFT_TYPE_ENUM = [
  "HANDMADE",
  "MACHINE_MADE",
  "CAST",
  "HANDCRAFTED",
  "STAMPED",
];

export const TECHNIQUE_ENUM = [
  "KUNDAN",
  "MEENAKARI",
  "TEMPLE",
  "FILIGREE",
  "ANTIQUE",
  "MODERN",
  "TRADITIONAL",
];
